module.exports = __webpack_public_path__ + "media/customizations/rianoridge/back-ef38ecaed3d388c094a50bdd5637af02.jpg";